import { ENABLED_LANGUAGES } from '@/utils/constants';

import ca from './locales/ca.json';
import en from './locales/en.json';
import es from './locales/es.json';
import lt from './locales/lt.json';
import rus from './locales/rus.json';
import sl from './locales/sl.json';
import sp from './locales/sp.json';

const LANGUAGES = {
  en: 'EN',
  es: 'EE',
  esp: 'ES',
  fr: 'FR',
  lt: 'LV',
  sl: 'SK',
  sp: 'SP', // Spanish
  rus: 'RU',
  ca: 'CA', // Catalan
};

export const DEFAULT_LANGUAGE = en;

export type LanguageCodeType = keyof typeof LANGUAGES;
export type LanguageNameType = (typeof LANGUAGES)[LanguageCodeType];

export const enabledLanguages = (ENABLED_LANGUAGES.filter((lang: string) =>
  Object.keys(LANGUAGES).includes(lang),
) as LanguageCodeType[]) || ['en'];

export const resources = {
  ca: { translation: ca },
  en: { translation: en },
  es: { translation: es },
  lt: { translation: lt },
  rus: { translation: rus },
  sl: { translation: sl },
  sp: { translation: sp },
};

export type TFunc = (key: string) => string;
export type tKeysUnion = keyof typeof DEFAULT_LANGUAGE;
export type tKeysType = { [key in tKeysUnion]: tKeysUnion };

export const tKeys = Object.fromEntries(
  Object.keys(en).map((key) => [key, key]),
) as tKeysType;

export const getLanguageNameByCode = (
  code: LanguageCodeType,
): LanguageNameType => LANGUAGES[code] || 'en';
